import { useContext } from "react";
import DataTableColumnPinningContext from "../components/DataTableColumnPinningContext";

const useTableColumnPinning = () => {
  const context = useContext(DataTableColumnPinningContext);
  if (!context) {
    throw new Error(
      "useTableColumnPinning must be used within a DataTableColumnPinningContext",
    );
  }
  return context;
};

export default useTableColumnPinning;
